// useWindowSize.js
import { useEffect, useState } from "react";

let subscribers = [];
let widthCache = typeof window !== "undefined" ? window.innerWidth : 0;

// 共享 resize 事件（避免每个组件都绑定一次）
function subscribe(callback) {
  subscribers.push(callback);
  return () => {
    subscribers = subscribers.filter((fn) => fn !== callback);
  };
}

function broadcast(width) {
  subscribers.forEach((fn) => fn(width));
}

if (typeof window !== "undefined") {
  window.addEventListener("resize", () => {
    const newWidth = window.innerWidth;
    if (newWidth !== widthCache) {
      widthCache = newWidth;
      broadcast(newWidth);
    }
  });
}

export function useWindowWidth() {
  const [width, setWidth] = useState(widthCache);

  useEffect(() => {
    return subscribe(setWidth);
  }, []);

  return width;
}
